import {PaginatedMetadata} from './PaginatedMetadata';

export class PaginatedResult {
  constructor(public metadata: PaginatedMetadata) {}
}
